import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@design-system/Sheet';
import { InfoIcon } from 'lucide-react';

const PlantVirusCard = ({ description, title }: { title: string; description: string }) => {
  return (
    <Sheet>
      <SheetTrigger>
        <div className="pr-1 pb-0.5">
          <InfoIcon
            size={16}
            aria-hidden
            className="inline-block ml-1 cursor-pointer"
          />
        </div>
      </SheetTrigger>
      <SheetContent modal>
        <SheetHeader>
          <SheetTitle className="text-primary typography-h1">
            {title}
          </SheetTitle>
          <SheetDescription className="typography-body text-secondary">
            {description}
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};

export default PlantVirusCard;
